/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Share_Copyright_RestrictedInputs */

const en_mobile_share_copyright_restricted = /** @type {(inputs: Mobile_Share_Copyright_RestrictedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only you can access this audio due to copyright restrictions.`)
};

const es_mobile_share_copyright_restricted = /** @type {(inputs: Mobile_Share_Copyright_RestrictedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo tú puedes acceder a este audio debido a restricciones de derechos de autor.`)
};

/**
* | output |
* | --- |
* | "Only you can access this audio due to copyright restrictions." |
*
* @param {Mobile_Share_Copyright_RestrictedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_share_copyright_restricted = /** @type {((inputs?: Mobile_Share_Copyright_RestrictedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Share_Copyright_RestrictedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_share_copyright_restricted(inputs)
	return en_mobile_share_copyright_restricted(inputs)
});